import { ProductDoc, ProductInventoryDoc, ProductSupplierDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { combineLatest } from 'rxjs';

import {
  observeProductInventories,
  observeProductSupplier,
  observeProducts,
} from 'src/utils/firebase/firebase-short-cut';

export type ProductInventoryWithDetail = ProductInventoryDoc & {
  products: ProductDoc[];
  supplier: ProductSupplierDoc | undefined;
};

export type { ProductSupplierDoc as ProductSupplier };

const useProductInventoriesWithDetail = (showDeleted = false) => {
  const [productSuppliers, setProductSuppliers] = useState<ProductSupplierDoc[]>([]);
  const [productInventories, setProductInventories] = useState<ProductInventoryWithDetail[]>([]);

  useEffect(() => {
    const supplier$ = observeProductSupplier();
    const product$ = observeProducts();
    const productInventory$ = observeProductInventories(showDeleted ? undefined : [['deletedAt', '==', null]]);

    const subscription = combineLatest([product$, productInventory$, supplier$]).subscribe(
      ([products0, inventories0, suppliers0]) => {
        const inventories = inventories0
          .map((inventory) => {
            const products = products0.filter((product) => product.inventoryId === inventory._id);
            const supplier = suppliers0.find((supplier) => supplier._id === inventory.purchaseConfig.supplierId);
            return {
              ...inventory,
              products,
              supplier,
            };
          })
          .sort((a, b) => a.inventoryName.localeCompare(b.inventoryName))
          .sort((a, b) => a.supplier?.name.localeCompare(b.supplier?.name || '') || 0);
        setProductInventories(inventories);
        setProductSuppliers(suppliers0);
      }
    );

    return () => subscription.unsubscribe();
  }, [showDeleted]);

  return { productSuppliers, productInventories };
};

export default useProductInventoriesWithDetail;
